import { render, staticRenderFns } from "./TeacherQrcode.vue?vue&type=template&id=30ae97b9&scoped=true&lang=html&"
import script from "./TeacherQrcode.vue?vue&type=script&lang=js&"
export * from "./TeacherQrcode.vue?vue&type=script&lang=js&"
import style0 from "./TeacherQrcode.vue?vue&type=style&index=0&id=30ae97b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ae97b9",
  null
  
)

export default component.exports